module.exports = __webpack_public_path__ + "media/images/countryrect/hr-f19033dbe57a6bbe13e2666a8734708b.svg";